import { createAxiosInstance } from '~/plugins/axios.plugin';
import { achievementType } from '~/helpers/achievementType';

export class Achievements {

  static SERVICE_NAME = 'achievements';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true,
      customHeaders  : {
        'Accept'       : 'application/json',
        'Content-Type' : 'application/json'
      }
    });
  }

  listAchievements(params) {
    return this.client.get(`/academic/achievements`, { params });
  }

  getAchievementById({ id, achievementTypeId = achievementType.BADGE }) {
    return this.client.get(`/academic/achievements/${id}?achievementTypeId=${achievementTypeId}`);
  }

  deleteAchievement(id) {
    return this.client.delete(`/academic/achievements/${id}`);
  }

  create(body) {
    return this.client.post(`/academic/achievements`, body);
  }

  update(id, body) {
    return this.client.put(`/academic/achievements/${id}`, body);
  }

  getDetails(id, params) {
    return this.client.get(`/academic/achievements/${id}/details`, { params });
  }
}

export default new Achievements();
